import { z } from 'zod'

export const unreadCountResponseSchema = z.object({
  count: z.number().int(),
})

export type UnreadCountResponseDto = z.infer<typeof unreadCountResponseSchema>
